/**
 * @generated SignedSource<<63210f5e46c8f3626bad468da2d15ee4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ContentKind = "ELearning";
export type ElementTypeV2 = "clozeText" | "enhancedText" | "file" | "freeTextSelfCheck" | "markMistakes" | "matrix" | "multipleChoice" | "order" | "persolog" | "persologEvaluation" | "persologQuestion" | "podcast" | "podcastWithTimestamp" | "reminder" | "text" | "textWithPages" | "video";
export type StructureType = "child" | "root";
export type TypeDefinitionType = "branch" | "content";
import { FragmentRefs } from "relay-runtime";
export type userRootNodeItemTree_TreeNodeInlineFragment$data = {
  readonly hasBeenPublishedOnce: boolean;
  readonly id: string;
  readonly parentId: string | null;
  readonly structureDefinition: {
    readonly coordinates: {
      readonly parentRef: string | null;
    };
    readonly definitionType: StructureType;
    readonly title: string;
  };
  readonly typeDefinition: {
    readonly childRefs?: ReadonlyArray<string>;
    readonly contentKind?: ContentKind;
    readonly definitionType: TypeDefinitionType;
    readonly elements?: ReadonlyArray<{
      readonly elementType: ElementTypeV2;
      readonly extension: {
        readonly points?: number;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ElementNode_ElementV2Fragment">;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Node_TreeNodeFragment">;
  readonly " $fragmentType": "userRootNodeItemTree_TreeNodeInlineFragment";
};
export type userRootNodeItemTree_TreeNodeInlineFragment$key = {
  readonly " $data"?: userRootNodeItemTree_TreeNodeInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userRootNodeItemTree_TreeNodeInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "userRootNodeItemTree_TreeNodeInlineFragment"
};

(node as any).hash = "2d72f7322766c79e9b8aae56fd0eb40f";

export default node;
